import { useInView } from 'react-intersection-observer'

import { useGetMarkingFormData } from '@/shared/api'
import { WorkspaceWithLinkDescriptor } from '@synapex/shared2/entities'

export const useMarkingFormQuery = (
    wld: WorkspaceWithLinkDescriptor,
    should: boolean
) => {
    const { ref, inView } = useInView({
        triggerOnce: false,
        rootMargin: '200px',
        delay: 100,
    })

    const shouldFetchMarkingFormData = Boolean(
        //link_id is 0 when optimistic link created on link creation
        inView && should && wld.link_id !== 0
    )

    const query = useGetMarkingFormData(wld, {
        enabled: shouldFetchMarkingFormData,
    })

    return {
        query,
        ref,
    }
}
